import React, { useEffect, useState } from 'react';
import { Modal, Select, notification } from 'antd';
import { projectApi, errorText } from './projectApi';
import PmTheme from './PmTheme';

/** From the incident detail: create a project task linked to this incident. */
const AddToProjectModal = ({ open, incident, onClose, onAdded }) => {
  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState(null);
  const [phases, setPhases] = useState([]);
  const [phaseId, setPhaseId] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setProjectId(null);
    setPhaseId(null);
    projectApi.list()
      .then(list => setProjects(list.filter(p => p.company === incident.company && p.status !== 'done')))
      .catch(() => setProjects([]));
  }, [open, incident]);

  useEffect(() => {
    setPhaseId(null);
    if (!projectId) { setPhases([]); return; }
    projectApi.get(projectId)
      .then(d => setPhases(d.items.filter(it => it.type === 'phase')))
      .catch(() => setPhases([]));
  }, [projectId]);

  const submit = () => {
    setSaving(true);
    projectApi.addIncidentToProject(incident.id, { projectId, phaseId })
      .then(() => { notification.success({ message: 'Požiadavka bola pridaná do projektu.' }); onAdded(); })
      .catch(err => notification.error({ message: errorText(err, 'Požiadavku sa nepodarilo pridať do projektu.') }))
      .finally(() => setSaving(false));
  };

  return (
    <PmTheme>
    <Modal
      open={open}
      title={`Pridať ${incident.niceid} do projektu`}
      onCancel={onClose}
      onOk={submit}
      okText="Pridať"
      cancelText="Zrušiť"
      okButtonProps={{ disabled: !projectId }}
      confirmLoading={saving}
      className="pm-modal"
      destroyOnClose
    >
      <div className="pm-field">
        <div className="pm-field-label">Projekt</div>
        <Select
          value={projectId}
          onChange={setProjectId}
          placeholder={projects.length ? 'Vyberte projekt' : `Firma ${incident.company} nemá aktívny projekt`}
          options={projects.map(p => ({ value: p.id, label: p.name }))}
          style={{ width: '100%' }}
          showSearch
          optionFilterProp="label"
        />
      </div>
      <div className="pm-field">
        <div className="pm-field-label">Fáza</div>
        <Select
          value={phaseId}
          onChange={setPhaseId}
          allowClear
          disabled={!projectId}
          placeholder="bez fázy"
          options={phases.map(p => ({ value: p.id, label: p.title }))}
          style={{ width: '100%' }}
        />
      </div>
    </Modal>
    </PmTheme>
  );
};

export default AddToProjectModal;
